import React, { useState } from "react";
import { useTranslation } from "@helpers/translate";
import TradeDirectionArrows from "../../../../TradeDirectionArrows";

/**
 * @param {object} props
 * @param {boolean} props.isLong
 * @param {(direction: 'long' | 'short') => void} props.onDirectionChange
 * @param {string} props.longColor
 * @param {string} props.shortColor
 * @param {string} props.mutedColor
 */
export const DirectionSwitch = ({
  isLong,
  onDirectionChange,
  longColor,
  shortColor,
  mutedColor,
}) => {
  const { __ } = useTranslation();
  const [hoveredDirection, setHoveredDirection] = useState(null);
  const resetHover = () => setHoveredDirection(null);

  return (
    <div className="trade-form__direction">
      <p className="trade-form__section-label">{__("futures.trade_details.direction")}</p>

      <div className="trade-form__segment" role="group" aria-label={__("futures.trade_details.direction")}>
        <button
          type="button"
          className={`trade-form__segment-btn${isLong ? " trade-form__segment-btn--active" : ""}`}
          aria-pressed={isLong}
          onClick={() => onDirectionChange("long")}
          onMouseEnter={() => setHoveredDirection("long")}
          onMouseLeave={resetHover}
          onBlur={resetHover}
        >
          <TradeDirectionArrows
            direction="long"
            size={20}
            color={isLong ? longColor : mutedColor}
            isAnimating={hoveredDirection === "long"}
          />
          {__("futures.long")}
        </button>

        <button
          type="button"
          className={`trade-form__segment-btn${!isLong ? " trade-form__segment-btn--active" : ""}`}
          aria-pressed={!isLong}
          onClick={() => onDirectionChange("short")}
          onMouseEnter={() => setHoveredDirection("short")}
          onMouseLeave={resetHover}
          onBlur={resetHover}
        >
          <TradeDirectionArrows
            direction="short"
            size={20}
            color={!isLong ? shortColor : mutedColor}
            isAnimating={hoveredDirection === "short"}
          />
          {__("futures.short")}
        </button>
      </div>
    </div>
  );
};
